import SchoolYearAPI from '@/apis/business/common/school-year.js'

export default {
  namespaced: true,
  state: {
    schoolYears: [],
    currentSchoolYear: null
  },
  mutations: {
    setSchoolYears (state, res) {
      state.schoolYears = res
    },

    setCurrentSchoolYear (state, res) {
      state.currentSchoolYear = res
    }
  },
  actions: {

    /**
     * @description Lấy dữ liệu danh sách năm học
     * @param {*} context
     * @returns
     */
    async getSchoolYears (context) {
      const res = await SchoolYearAPI.getAsync('/schoolyears')
      return res.Data?.SchoolYears
    //   context.commit('setSchoolYears', res.Data?.SchoolYears)
    }
  }
}
